export function deleteCustomCsvCustomer(refetch: () => void) {
  return {
    type: 'DELETE_CUSTOM_CSV_CUSTOMER',
    payload: {
      refetch,
    },
  };
}
